// local vars
export const VAR_REFRESH_TOKEN = 'refreshToken';
export const VAR_ACCESS_TOKEN = 'accessToken';

// internal vars
export const VAR_PUBLIC_ENDPOINTS = [
  'login',
  'admin/login',
  'register',
  'reset-password',
  'request-reset-password',
  'social-registry-login',
  'refresh',
  'logout',
  'provinces',
  'districts',
  'sectors',
  'cells',
  'villages',
  'cases/analytics',
  'cases/analytics/case-graph',
  'announcements/published',
  'tip-offs-categories',
  'files',
  'nida',
  'complaints/anonymous',
  'complaints/search',
  'complaints/get-complaint-tracking-otp',
  'complaints/tracking',
  'tip-offs',
];
export const VAR_NATIONAL_ID_LENGTH = 16;
export const VAR_REGISTRATION_STEPS = [
  'NID_VERIFICATION',
  'PHONE_NUMBER_SELECTION',
  'PHONE_NUMBER_VERIFICATION',
  'COMPLETION',
] as const;
